import React, {Component}  from 'react'
import {modal} from 'react-redux-modal' // The modal emitter
import {Modal, Button}  from 'react-bootstrap'

export default class StsModal extends Component {
  constructor(props) {
    super(props);
    
  }

  removeThisModal() {
    this.props.removeModal();
  }



  render() {

  	const modalInstance = (
  		  <div className="static-modal">
  		    <Modal.Dialog>
  		      <Modal.Header>
  		        <Modal.Title>Modal title</Modal.Title>
  		      </Modal.Header>

  		      <Modal.Body>
	  		      <p>this is my modal</p>
	  	        <button
	  	          type="button"
	  	          onClick={this.removeThisModal.bind(this)}>
	  	          close this modal
	  	        </button>
  		      </Modal.Body>

  		      <Modal.Footer>
  		        <Button>Close</Button>
  		        <Button bsStyle="primary">Save changes</Button>
  		      </Modal.Footer>

  		    </Modal.Dialog>
  		  </div>
  		);



    return (
      <div>
        {modalInstance}
      </div>
    );
  }
}